import { render, staticRenderFns } from "./message-v3-etf.vue?vue&type=template&id=45a6c1af"
import script from "./message-v3-etf.vue?vue&type=script&lang=js"
export * from "./message-v3-etf.vue?vue&type=script&lang=js"
import style0 from "./message-v3-etf.vue?vue&type=style&index=0&id=45a6c1af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports